import styled from 'styled-components';
import { Button } from '@styles/shared';
import backIcon from '@assets/icons/nav/back-light.svg';

export const EventDetailControlHeaderContainer = styled.div`
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  isolation: isolate;
  width: 100%;
  height: 110px;
  display: flex;
  padding: 20px 10px 20px 17px;
  overflow: hidden;

  p {
    line-height: 1;
  }
`;

export const EventDetailControlHeaderMask = styled.div`
  position: absolute;
  z-index: -5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
`;

export const EventDetailControlHeaderBackground = styled.div`
  > img {
    position: absolute;
    z-index: -10;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
  }
`;

export const EventDetailControlHeaderBackLink = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33px;
  height: 33px;
  padding: 0;
  border-radius: 50%;
  background: url(${backIcon}) no-repeat center;

  :hover {
    background: url(${backIcon}) no-repeat center;
  }
`;

export const EventDetailControlHeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 8px;

  > div {
    display: flex;
    align-items: center;

    :not(:first-child) {
      padding-top: 10px;
    }

    > img {
      margin-right: 7px;
      margin-bottom: auto;
      width: 12px;
      height: 12px;
    }
  }
`;
